<div class="feature-store-no-access" role="status">
  <app-display-icon
    [border]="false"
    [colour]="iconColourEnum.red"
    [icon]="icons.lockClosedOutline">
  </app-display-icon>
  <h3 class="feature-store-no-access-title">Insufficient Access</h3>
  <p class="feature-store-no-access-text">
    You do not have permission to open this page for {{ displayStoreName }}.
    Change to a store you have access for.
  </p>
</div>
